
import { businessNo } from '../config/env'
import { baiduReportAPI } from '../service/getData'

/**
 * 百度转化埋点统计代码
 * @param {*} obj.newType 转化类型
 * @param {string|undefined} obj.orderNo 订单编号
 * @param {string} obj.mobile 手机号码
 */
export const baiduReport = (obj) => {
  try {
    // 如果是百度OCPC推广进来的用户，调用用户转化接口
    const href = decodeURIComponent(window.location.href.replace(location.hash , "" ));
    const bd_vid = sessionStorage.getItem('bd_vid')
    const channel = QueryString('channel') || localStorage.getItem("channel") || businessNo
    console.log('bd_vid = ' + bd_vid)
    if (href.toString().indexOf('bd_vid') > -1) {
      baiduReportAPI({
        logidUrl: href,
        newType: obj.newType,
        businessNo: channel,
        orderNo: obj.orderNo,
        mobile: obj.mobile
      })
    } else if (bd_vid) {
      baiduReportAPI({
        logidUrl: `${href}${window.location.search ? '&' : '?'}bd_vid=${bd_vid}`,
        newType: obj.newType,
        businessNo: channel,
        orderNo: obj.orderNo,
        mobile: obj.mobile
      })
    }
  } catch (err) {
    console.log(err)
  }
}

/**
 * 获取地址栏参数
 * @param {*} name
 * @returns
 */
export const QueryString = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null;
}



// WEBPACK FOOTER //
// ./src/js/common.js